import React from "react";

function Signup() {
  return <div>signup</div>;
}

export default Signup;
